import { render, staticRenderFns } from "./ActionSwap.vue?vue&type=template&id=f767bfb2&scoped=true&"
import script from "./ActionSwap.vue?vue&type=script&setup=true&lang=ts&"
export * from "./ActionSwap.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f767bfb2",
  null
  
)

export default component.exports